<template v-if="division">
  <div v-if="division !== null">
    <wc-data-box
      v-if='division'
      :title="'Today\'s ' + schedule.name + ' Leads'"
      :titleIcon='division.icon'
      :titleIconColor='division.icon_color'
    >
      <v-list v-if="routes.length">
        <v-list-item v-for='r in routes' :key='r.id' @click='openRoute(r)'>
          <v-list-item-content>
            <v-list-item-title v-if='r.lead'>
              {{ r.lead_obj.name_display }}
            </v-list-item-title>
            <v-list-item-title v-else>
              Route (no lead)
            </v-list-item-title>
            <v-list-item-subtitle>
              <span v-if='r.copilot'>{{ "with " + r.copilot_obj.name_display }}</span>
              <span v-else>Solo </span>
              <template v-for='other_copilot in r.other_copilots'>
                <div :key='other_copilot.id'>
                  <span >{{ "and " + other_copilot.pilot_data.name_display }}</span>
                </div>
              </template>
              <span v-if='r.vehicle'>{{ " in " + r.vehicle_obj.name }}</span>
              <span v-else> (no vehicle specified)</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </wc-data-box>
  </div>
</template>

<script>
export default {
  name: 'todays-routes',
  props: {
    routes: {
      required: true
    },
    schedule: {
      required: true
    },
    division: {
      required: true
    },
  },
  mounted(){
    console.log(this.division);
  },
  methods: {
    openRoute (r) {
      this.$router.push({ name: 'FieldRoute', params: { id: r.id } })
    }
  }
}
</script>
